/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Home_Ocop_CertificatesInputs */

const vi_shop_home_ocop_certificates = /** @type {(inputs: Shop_Home_Ocop_CertificatesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giấy chứng nhận (tối đa ${i?.max}, kéo để đổi thứ tự)`)
};

/**

* @param {Shop_Home_Ocop_CertificatesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_ocop_certificates = /** @type {((inputs: Shop_Home_Ocop_CertificatesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Ocop_CertificatesInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_ocop_certificates(inputs)
});